import { render, staticRenderFns } from "./Deviations.vue?vue&type=template&id=4be50434&scoped=true&"
import script from "./Deviations.vue?vue&type=script&lang=js&"
export * from "./Deviations.vue?vue&type=script&lang=js&"
import style0 from "./Deviations.vue?vue&type=style&index=0&id=4be50434&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be50434",
  null
  
)

/* custom blocks */
import block0 from "./Deviations.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports